import type { CSSProperties } from 'react';

const notificationMenuItemClassName = 'notification-menu-item';
const notificationMenuItemStyle: CSSProperties = {
    height: 'auto',
    lineHeight: 'normal',
    padding: '0.75rem',
};

export { notificationMenuItemClassName, notificationMenuItemStyle };
